import { loan_application } from '@axo/shared/data-access/types';

export const TRUSTPILOT_LINK =
  'http://widget.trustpilot.com/trustbox-data/53aa8807dec7e10d38f59f32?businessUnitId=577008a20000ff0005919d8a&locale=da-DK';

export const INTEREST_RATE = 0.0;
export const MONTHLY_FEE = 0;
export const RATES = {
  MIN: 9.0,
  LOW: 3.6,
  ESTABLISH: 3.0,
  HIGH: 20.95,
} as const;

export const SSN_REGEX =
  /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])(0[1-9]|1[0-2])[0-9]{2}[0-9]{4}$/;

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const SEQUENCE_REGEX = /(1234567)|(0000000)/;

export const DEFAULT_LOAN_AMOUNT = 250_000;
export const DEFAULT_LOAN_DURATION = 12;
export const MIN_LOAN_AMOUNT = 10_000;
export const MAX_LOAN_AMOUNT = 400_000;

export const PHONE_REGEX =
  /^(?:(?:00|\+)?45)?(?=2|3[01]|4[012]|4911|5[0-3]|6[01]|[78]1|9[123])\d{8}$/;

type OptionList<T> = { value: T; text: string }[];

export const radioOptions = [
  { text: 'yes', value: 'Yes' },
  { text: 'no', value: 'No' },
];

export const refinanceableDebtsTypes: loan_application.DebtType[] = [
  loan_application.DebtType.Personal,
];

export const debtTypeOptions: OptionList<loan_application.DebtType> = [
  {
    text: 'Debt.Type.Personal',
    value: loan_application.DebtType.Personal,
  },
  {
    text: 'Debt.Type.Housing',
    value: loan_application.DebtType.Housing,
  },
  {
    text: 'Debt.Type.Car',
    value: loan_application.DebtType.Car,
  },
  {
    text: 'Debt.Type.Student',
    value: loan_application.DebtType.Student,
  },
];

export const initialPurposeOptions: OptionList<loan_application.Purpose> = [
  { text: 'yes', value: loan_application.Purpose.RefinancingLoan },
  { text: 'no', value: loan_application.Purpose.Other },
];

export const purposeOptions: OptionList<loan_application.Purpose> = [
  {
    text: 'Purpose.Vehicle',
    value: loan_application.Purpose.Vehicle,
  },
  {
    text: 'Purpose.Renovation',
    value: loan_application.Purpose.Renovation,
  },
  {
    text: 'Purpose.RealEstate',
    value: loan_application.Purpose.RealEstate,
  },
  {
    text: 'Purpose.Medical',
    value: loan_application.Purpose.Medical,
  },
  {
    text: 'Purpose.SpecialOccasion',
    value: loan_application.Purpose.SpecialOccasion,
  },
  {
    text: 'Purpose.Holiday',
    value: loan_application.Purpose.Holiday,
  },
  {
    text: 'Purpose.Investment',
    value: loan_application.Purpose.Investment,
  },
  {
    text: 'Purpose.Other',
    value: loan_application.Purpose.Other,
  },
  {
    text: 'Purpose.RefinancingLoan',
    value: loan_application.Purpose.RefinancingLoan,
  },
  {
    text: 'Purpose.GreenEnergy',
    value: loan_application.Purpose.GreenEnergy,
  },
];

export const housingOptions: OptionList<loan_application.Residence> = [
  {
    text: 'HousingType.Rental',
    value: loan_application.Residence.Rental,
  },
  {
    text: 'HousingType.OwnHouse',
    value: loan_application.Residence.OwnHouse,
  },
  {
    text: 'HousingType.OwnApartment',
    value: loan_application.Residence.OwnApartment,
  },
  {
    text: 'HousingType.CooperativeApartment',
    value: loan_application.Residence.CooperativeApartment,
  },
];

export const maritalStatusOptions: OptionList<loan_application.MaritalStatus> =
  [
    {
      value: loan_application.MaritalStatus.Single,
      text: 'MaritalStatus.Single',
    },
    {
      value: loan_application.MaritalStatus.Married,
      text: 'MaritalStatus.Married',
    },
    {
      value: loan_application.MaritalStatus.Cohabiting,
      text: 'MaritalStatus.Cohabiting',
    },
  ];

export const employmentOptions: OptionList<loan_application.EmploymentStatus> =
  [
    {
      text: 'EmploymentStatus.Permanent',
      value: loan_application.EmploymentStatus.Permanent,
    },
    {
      text: 'EmploymentStatus.Entrepreneur',
      value: loan_application.EmploymentStatus.Entrepreneur,
    },
    {
      text: 'EmploymentStatus.Student',
      value: loan_application.EmploymentStatus.Student,
    },
    {
      text: 'EmploymentStatus.Pensioner',
      value: loan_application.EmploymentStatus.Pensioner,
    },
    {
      text: 'EmploymentStatus.Unemployed',
      value: loan_application.EmploymentStatus.Unemployed,
    },
  ];

export const amountOfChildrenOptions: OptionList<string> = [
  { text: '0', value: '0' },
  { text: '1', value: '1' },
  { text: '2', value: '2' },
  { text: '3', value: '3' },
  { text: '4+', value: '4' },
];

export const childrenAgeOptions: OptionList<string> = [
  { text: '0-2', value: '2' },
  { text: '3-6', value: '6' },
  { text: '7-10', value: '10' },
  { text: '11-14', value: '14' },
  { text: '15-17', value: '17' },
];

export enum Citizenship {
  EU = 'EU',
  Other = 'Other',
  Nordic = 'Nordic',
}

export const citizenshipOptions: OptionList<string> = [
  { text: 'Citizenship.EU', value: Citizenship.EU },
  { text: 'Citizenship.Other', value: Citizenship.Other },
  { text: 'Citizenship.Nordic', value: Citizenship.Nordic },
];

export enum ResidencePermit {
  No = 0,
  Temporary = 1,
  Permanent = 2,
  ProofRegistration = 3,
  ProofRightToUnlimited = 4,
}

export const residencePermitOptions: OptionList<string> = [
  { text: 'ResidencePermit.Temporary', value: `${ResidencePermit.Temporary}` },
  { text: 'ResidencePermit.Permanent', value: `${ResidencePermit.Permanent}` },
  {
    text: 'ResidencePermit.Registration',
    value: `${ResidencePermit.ProofRegistration}`,
  },
  {
    text: 'ResidencePermit.Unlimited',
    value: `${ResidencePermit.ProofRightToUnlimited}`,
  },
];

export const yearsAsBankCustomer: OptionList<string> = [
  { text: '0-3 år', value: '3' },
  { text: '4-7 år', value: '7' },
  { text: '+8 år', value: '12' },
];

// https://git.lendme.dk/lendme/customer-interface/-/blob/development/src/app/views/routes/steps/loan-details-step/loan-details-step.component.html#L236
export const debtCreditorsOptions: OptionList<string> = [
  { value: 'Alfalån', text: 'Alfalån' },
  { value: 'Alm. Brand Bank', text: 'Alm. Brand Bank' },
  { value: 'Anna Finans', text: 'Anna Finans' },
  { value: 'Arbejdernes Landsbank', text: 'Arbejdernes Landsbank' },
  { value: 'Aurora Lån', text: 'Aurora Lån' },
  { value: 'Bank Norwegian', text: 'Bank Norwegian' },
  { value: 'Basis Bank', text: 'Basis Bank' },
  { value: 'Bedre Kredit', text: 'Bedre Kredit' },
  { value: 'BG Bank', text: 'BG Bank' },
  { value: 'Bonuslån', text: 'Bonuslån' },
  { value: 'Cashper', text: 'Cashper' },
  { value: 'Coop Ny Bank', text: 'Coop Ny Bank' },
  { value: 'D:E:R', text: 'D:E:R ' },
  { value: 'Danaktiv', text: 'Danaktiv' },
  { value: 'Danske Bank', text: 'Danske Bank' },
  {
    value: 'DLR Kredit A/S',
    text: 'DLR Kredit A/S',
  },
  { value: 'Ekspert Lån', text: 'Ekspert Lån' },
  { value: 'Ellos', text: 'Ellos' },
  { value: 'Entercard', text: 'Entercard' },
  { value: 'Express Bank A/S', text: 'Express Bank A/S' },
  { value: 'Extra Cash', text: 'Extra Cash' },
  { value: 'Facit', text: 'Facit Bank' },
  { value: 'Ferratum', text: 'Ferratum' },
  { value: 'Folkelånet', text: 'Folkelånet' },
  { value: 'Forbrugsforeningen', text: 'Forbrugsforeningen' },
  { value: 'Føniks Privatlån', text: 'Fønix Privatlån' },
  { value: 'GE Money Bank', text: 'GE Money Bank' },
  { value: 'Go Kredit', text: 'Go Kredit' },
  { value: 'HG Finans', text: 'HG Finans' },
  { value: 'Hotlån', text: 'Hotlån' },
  { value: 'Ikano Bank', text: 'Ikano Bank' },
  { value: 'Intrum / GreenCredit', text: 'Intrum / GreenCredit' },
  { value: 'IQ Finans', text: 'IQ Finans' },
  { value: 'Jyske Bank', text: 'Jyske Bank' },
  { value: 'Jyske Finans', text: 'Jyske Finans' },
  {
    value: 'Jyske Realkredit A/S',
    text: 'Jyske Realkredit A/S',
  },
  { value: 'Kassekreditten', text: 'Kassekreditten' },
  { value: 'Klarna', text: 'Klarna' },
  { value: 'Kredit Nu', text: 'Kredit Nu' },
  { value: 'Kreditstatus', text: 'Kreditstatus' },
  { value: 'Kronelån', text: 'Kronelån' },
  { value: 'Kvikto', text: 'Kvikto' },
  { value: 'Leasy', text: 'Leasy' },
  { value: 'Lendon', text: 'Lendon' },
  { value: 'Lån & Sparbank', text: 'Lån & Sparbank' },
  { value: 'LånLet', text: 'LånLet' },
  { value: 'Mini Finans', text: 'Mini Finans' },
  { value: 'Mini Lån', text: 'Mini Lån' },
  { value: 'Modus Finans', text: 'Modus Finans' },
  { value: 'Moment Lån', text: 'Moment Lån' },
  { value: 'Nordea', text: 'Nordea' },
  { value: 'Nordea Finans', text: 'Nordea Finans' },
  { value: 'Nordea Kredit', text: 'Nordea Kredit' },
  {
    value: 'Nordea Kredit Realkreditaktieselskab',
    text: 'Nordea Kredit Realkreditaktieselskab',
  },
  { value: 'Nordea30 SU Styrrelsen', text: 'Nordea30 SU Styrrelsen' },
  { value: 'Nordcredit', text: 'Nordcredit' },
  { value: 'Nordic Lån', text: 'Nordic Lån' },
  { value: 'Nordisk Lån', text: 'Nordisk Lån' },
  { value: 'Nykredit', text: 'Nykredit' },
  {
    value: 'Nykredit Realkredit A/S',
    text: 'Nykredit Realkredit A/S',
  },
  { value: 'Paymark Finans', text: 'Paymark Finans' },
  { value: 'Prima Lån', text: 'Prima Lån' },
  { value: 'Re:member', text: 'Re:member ' },
  {
    value: 'Realkredit Danmark',
    text: 'Realkredit Danmark',
  },
  { value: 'Resurs Bank', text: 'Resurs Bank' },
  { value: 'Rotoblån', text: 'Robotlån' },
  { value: 'SEB Kort', text: 'SEB Kort' },
  { value: 'Santander', text: 'Santander' },
  { value: 'Selene Finans', text: 'Selene Finans' },
  { value: 'Simbo', text: 'Simbo' },
  { value: 'Spar Nord', text: 'Spar Nord' },
  { value: 'Spargo Finans', text: 'Spargo Finans' },
  { value: 'Sparxpres', text: 'Sparxpres' },
  { value: 'SU Styrelsen', text: 'SU Styrelsen' },
  { value: 'Sydbank', text: 'Sydbank' },
  {
    value: 'Tjenestemændenes Låneforening',
    text: 'Tjenestemændenes Låneforening',
  },
  {
    value: 'Totalkredit A/S',
    text: 'Totalkredit A/S',
  },
  { value: 'Turbolån', text: 'Turbolån' },
  { value: 'Uno Finans', text: 'Uno Finans' },
  { value: 'Viabill', text: 'Viabill' },
  { value: 'Vivus', text: 'Vivus' },
  { value: 'Zetfinans', text: 'Zetfinans' },
  { value: 'Zaplo', text: 'Zaplo' },
  { value: 'Årsopgørelse', text: 'Årsopgørelse' },
  { value: 'Øvrige', text: 'Øvrige' },
];
